export const GET_ALL_UPLOAD_PRICES = "GET_ALL_UPLOAD_PRICES";

export const GET_ALL_UPLOAD_PRICES_PENDING = "GET_ALL_UPLOAD_PRICES_PENDING";

export const GET_ALL_UPLOAD_PRICES_SUCCESS = "GET_ALL_UPLOAD_PRICES_SUCCESS";

export const GET_ALL_UPLOAD_PRICES_ERROR = "GET_ALL_UPLOAD_PRICES_ERROR";

export const UPLOAD_COMMODITY_PRICES = "UPLOAD_COMMODITY_PRICES";

export const UPLOAD_COMMODITY_PRICES_PENDING =
  "UPLOAD_COMMODITY_PRICES_PENDING";

export const UPLOAD_COMMODITY_PRICES_SUCCESS =
  "UPLOAD_COMMODITY_PRICES_SUCCESS";

export const UPLOAD_COMMODITY_PRICES_ERROR = "UPLOAD_COMMODITY_PRICES_ERROR";
